import React, { useEffect, useState } from 'react'
import className from 'classnames/bind'

import style from './MyhouseContents.module.scss'

import { BOARD_CONTENT_MAX_LENGTH, MY_HOUSE_BOARD_TYPE } from '@Root/contants/myhouse'
import useBoardRegister from '@Hooks/myhouse/board/useBoardRegister'
import { handleNclickMix } from '@Helpers/nclick'
import { NCLICK } from '@Root/contants/lcs'
import useBrowser from '@Hooks/myhouse/useBrowser'

const cx = className.bind(style)

type Props = {
  handleBlur?: any
  content?: string
  boardType: MY_HOUSE_BOARD_TYPE
}

const MyhouseContents: React.FC<Props> = ({ handleBlur, content, boardType }: Props) => {
  const [text, setText] = useState('')
  const { validateSymbols } = useBoardRegister()
  const { isIphone, isIpad, isSafari } = useBrowser()
  const [maxLength, setMaxLength] = useState(BOARD_CONTENT_MAX_LENGTH)

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    if (!validateSymbols(event.target.value)) {
      return
    }

    if (event.target.value.length > BOARD_CONTENT_MAX_LENGTH) {
      return
    }

    if (isIphone || isIpad || isSafari) {
      const newlineCount = (event.target.value.match(/\r\n|\r|\n/g) || []).length
      setMaxLength(BOARD_CONTENT_MAX_LENGTH + newlineCount)
    }

    setText(event.target.value)
  }

  useEffect(() => {
    setText(content || '')
  }, [content])

  return (
    <div className={cx('myhouse_contents')}>
      <textarea
        placeholder="내용을 입력해 주세요."
        maxLength={maxLength}
        className={cx('myhouse_contents_textarea')}
        onChange={handleChange}
        onBlur={(event) => handleBlur(event.target.value)}
        onClick={handleNclickMix(boardType === MY_HOUSE_BOARD_TYPE.NOTICE ? NCLICK.MY_HOUSE.NOTICE_ENROL.CONTENT : NCLICK.MY_HOUSE.REVIEW_ENROL.CONTENT)}
        value={text}
      />
      <span className={cx('myhouse_contents_length')}>
        <em className={cx('myhouse_length_count')}>{text.length}</em> / {BOARD_CONTENT_MAX_LENGTH}글자
      </span>
    </div>
  )
}

export default MyhouseContents
